import React, { useEffect, useState } from "react";
import { PaymentVoucher } from "../../../../models/PaymentVoucher";
import { TransactionService } from "../../../../services/TransactionService";
import { VoucherProgramType } from "../../../../constants/VoucherContants";
import { PaymentRowLayout } from "./PaymentRowLayout";

export default function PaymentVouchers(props) {
  const { transactionId: id } = props;
  const [data, setData] = useState([]);

  useEffect(() => {
    new TransactionService().getPaymentVouchers(id).then((response) => {
      setData(response.map((item) => new PaymentVoucher(item)));
    });
  }, [id]);

  return (
    <>
      {data.length > 0 &&
        data.map((paymentVoucher) => (
          <PaymentRowLayout
            first={`${
              paymentVoucher.voucherProgramName
            }${VoucherProgramType.getName(paymentVoucher.voucherProgramType)}`}
            second={paymentVoucher.voucherProgramCode}
            third={paymentVoucher.amountCollect.toFixed(6)}
          />
        ))}
    </>
  );
}